import React from 'react';
import cn from 'classnames';
import {StandardProps} from '.';

export interface BackdropProps extends StandardProps {
  open: boolean;
}

export const Backdrop = React.forwardRef<HTMLDivElement, BackdropProps>(
  ({children, className, open, ...restProps}, ref) => {
    return (
      <div ref={ref} className={cn('backdrop', className)} {...restProps}>
        {children}
      </div>
    );
  },
);

export default Backdrop;
